// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file sales/refund_sale.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { RefundItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.RefundSaleRequest
 */
export class RefundSaleRequest extends Message<RefundSaleRequest> {
  /**
   * List of items to be refunded
   *
   * @generated from field: repeated com.neulink.pharmacy.RefundItem items = 1;
   */
  items: RefundItem[] = [];

  /**
   * The ID of the original sale being refunded
   *
   * @generated from field: string sale_id = 2;
   */
  saleId = "";

  /**
   * Reason for the refund
   *
   * @generated from field: string reason = 3;
   */
  reason = "";

  constructor(data?: PartialMessage<RefundSaleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.RefundSaleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: RefundItem, repeated: true },
    { no: 2, name: "sale_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefundSaleRequest {
    return new RefundSaleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefundSaleRequest {
    return new RefundSaleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefundSaleRequest {
    return new RefundSaleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RefundSaleRequest | PlainMessage<RefundSaleRequest> | undefined, b: RefundSaleRequest | PlainMessage<RefundSaleRequest> | undefined): boolean {
    return proto3.util.equals(RefundSaleRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.RefundSaleResponse
 */
export class RefundSaleResponse extends Message<RefundSaleResponse> {
  constructor(data?: PartialMessage<RefundSaleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.RefundSaleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefundSaleResponse {
    return new RefundSaleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefundSaleResponse {
    return new RefundSaleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefundSaleResponse {
    return new RefundSaleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RefundSaleResponse | PlainMessage<RefundSaleResponse> | undefined, b: RefundSaleResponse | PlainMessage<RefundSaleResponse> | undefined): boolean {
    return proto3.util.equals(RefundSaleResponse, a, b);
  }
}

